import React from 'react'
import TextField, { TextFieldProps } from './textField'

const PhoneField: React.FC<TextFieldProps> = ({ autoComplete, type, ...rest }) => {
    return <TextField autoComplete="tel-national" type="tel" {...rest} />
}

export default PhoneField
